import React, { useContext, useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { useHistory } from "react-router-dom";
import "./Oneshot.css";
import logo from "./img/oneshot.jpeg";
import Login from "./Login"
import MenuMain from "./MenuMain";
import AdminProyecto from "./AdminProyecto";
import EstadoProyectos from "./EstadoProyectos";
import EstadoMantenimiento from "./EstadoMantenimiento";
import NuevoProyecto from "./NuevoProyecto";
import Mantenimiento from "./Mantenimiento";
import Administracion from "./Administracion";
import RegistroHoras from "./RegistroHoras";
import MisTareas from "./MisTareas"
import Actualizacion from "./Actualizacion"
import Utilizacion from "./Utilizacion"
import { AppContext } from "./index";
import { bkMain, bkNavegacion } from "./general"

export default function App() {
  let { usrLogged } = useContext(AppContext);
  let history = useHistory();

  const [login, setLogin] = useState(false);
  const [loginOK, setLoginOK] = useState(false);

  useEffect(() => {
    document.addEventListener("contextmenu", (e) => e.preventDefault());
  });

  useEffect(() => {
    if (login && loginOK) {
      if (window.confirm("Desea cerrar la sesión?")) {
        usrLogged.logOUT();
        setLoginOK(false)
        document.getElementById("htmlLogin").innerHTML = "";
        history.push("/");
      }
    }
  }, [login, loginOK, history, usrLogged])

  return (
    <div style={Smain}>
      <nav style={Sbarranavegacion}>

        <div style={ScentroBarraNav}>
          <div id="htmlTituloPag">Gestión de Proyectos</div>
          <div style={{ fontSize: "1.7vh" }} id="htmlTituloPagS"></div>
        </div>

        <div style={Slogo} onClick={() => setLogin(true)}>
          <h6 id="htmlLogin" style={{ marginTop: "10px" }}>{""}</h6>
          &nbsp;&nbsp;&nbsp;
          {loginOK ? (
            <img src={usrLogged.url} alt="fotonn" width="45px" height="45px" style={{ clipPath: "circle(50%)" }} />
          ) : (
              <img src={logo} alt="logo" width="45px" height="45px" float="right" draggable="false" style={{ clipPath: "circle(50%)" }} />)}
          OneShot
        </div>
      </nav>

      <div style={Scuerpo}>
        <MenuMain />

        <div style={Sroute}>
          <Route path="/Estado Proyectos" component={EstadoProyectos} />
          <Route path="/AdminProyecto" component={AdminProyecto} />
          <Route path="/Estado Mantenimiento" component={EstadoMantenimiento} />
          <Route path="/Nuevo Proyecto" component={NuevoProyecto} />
          <Route path="/Mis Tareas" component={MisTareas} />
          <Route path="/Actualizacion" component={Actualizacion} />
          <Route exact path="/Administracion" component={Administracion} />
          <Route path="/Registro Horas" component={RegistroHoras} />
          <Route path="/Utilizacion" component={Utilizacion} />
          <Route path="/Mantenimiento" component={Mantenimiento} />
        </div>
      </div>

      {login && !loginOK && <Login setLoginOK={setLoginOK} setLogin={setLogin} />}

    </div>
  );
}

const Smain = {
  overflow: "hidden",
  userSelect: "none",
  height: window.innerHeight,
  width: window.innerWidth,
  color: "white"
};

const Sbarranavegacion = {
  background: bkNavegacion,
  height: "10vh",
  width: "100vw",
  color: "white",
  fontSize: "6vh",
  display: "grid",
  gridTemplateColumns: "70% 30%",
  alignItems: "center",
};

const ScentroBarraNav = {
  display: "flex",
  textAlign: "center",
  justifyContent: "flex-end",
  flexDirection: "column",
  fontSize: "4vh",
  fontWeight: 700,
};

const Slogo = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  fontSize: "1.5vh",
  marginRight: "20px",
  cursor: "pointer"
};

const Scuerpo = {
  display: "flex",
  flexDirection: "row",
};

const Sroute = {
  background: bkMain,
  minHeight: "90vh",
  minWidth: "96.7%",
  color: "white",
  overflow: "hidden",
};
